import { ClassLocationDTO } from "../dto/classes/ClassLocationDTO";
import { ClassLocation } from "../models/Classes/ClassLocation";
import { useUtility } from "@/composables/useUtility";

export const classLocationMapper = (dto: ClassLocationDTO) => {
  const { mapPseudoBool } = useUtility();

  return new ClassLocation({
    id: dto.locationId,
    name: dto.locationName,
    active: mapPseudoBool(dto.active) ?? false,
  });
};
